import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { StorageProvider } from '../interface/storage-provider.interface';
import { Cookie } from '../model/cookie';

@Injectable()
export class CookieService implements StorageProvider {
  private documentIsAccessible: boolean;

  constructor(@Inject(DOCUMENT) private document: any) {
    this.documentIsAccessible = document !== undefined;
  }

  set(key: string, value: any, expires?: Date | number, path?: string, domain?: string): void {
    if (!this.documentIsAccessible) {
      return;
    }

    if (value instanceof Object) {
      value = JSON.stringify(value);
    }

    const cookie: Cookie = new Cookie(key, value, expires, path, domain);
    this.document.cookie = cookie.getString();
  }

  get(key: string): any {
    if (!this.documentIsAccessible || !this.isExist(key)) {
      return '';
    }

    const regExp: RegExp = this.getCookieRegExp(key);
    const result: RegExpExecArray = regExp.exec(this.document.cookie);

    return this.parseToObject(result[1]);
  }

  remove(key: string, path?: string): void {
    if (!this.documentIsAccessible) {
      return;
    }

    this.document.cookie = key + '=; expires=' + new Date(0) + '; path=' + path + ';';
  }

  private isExist(key: string): boolean {
    const encodedKey: string = encodeURIComponent(key);
    const regExp: RegExp = this.getCookieRegExp(encodedKey);
    const exists: boolean = regExp.test(this.document.cookie);

    return exists;
  }

  private getCookieRegExp(name: string): RegExp {
    const escapedName: string = name.replace(/([\[\]\{\}\(\)\|\=\;\+\?\,\.\*\^\$])/gi, '\\$1');

    return new RegExp('(?:^' + escapedName + '|;\\s*' + escapedName + ')=(.*?)(?:;|$)', 'g');
  }

  private parseToObject(stringifyData: any): any {
    let value: any = decodeURIComponent(stringifyData);

    try {
      value = JSON.parse(value);
    } catch (e) {}

    return value;
  }
}
